import { h } from "preact";
import { useState, useEffect } from "preact/hooks";


export default function InscriptionAmbassadeur() {

	console.log("DevenirAmbassadeur")

	return (<div>Devenir un Ambassadeur</div>)
}